module.exports = __webpack_public_path__ + "static/media/cloud-girls.9f4ccc14.png";